<template>
	<div id="app">
		<div v-if="open_type === 1 && status_code === 200">
			<TheGlobal
				:global="global"
				:extra="extra"
				:sns="sns"
				:organization="organization"
				:information="information"
				:rss="rss"
			/>
			<div class="iv2-side position-fixed">
				<TheExtra :extra="extra" />
				<TheExtraSNS :sns="sns" :rss="rss" />
			</div>
			<transition mode="out-in" :name="pageAnimation">
				<router-view :animation="pageAnimation" :blog="rss" />
			</transition>

			<TheFooter
				:footer="footer"
				:sns="sns"
				:organization="organization"
				:information="information"
				:rss="rss"
			/>

			<!-- タブレット、スマホのみ表示 -->
			<TheBottom :bottom="bottom" />

			<!-- デモサイトビルド時のみコメントイン -->
			<BaseColor />
		</div>

		<!-- サイト非公開 -->
		<div v-else-if="open_type === 0 && status_code === 200">
			<Closed />
		</div>

		<!-- 500エラー -->
		<div v-else-if="status_code === 500">
			<Error500 />
		</div>

		<!-- 503エラー -->
		<div v-else-if="status_code === 503">
			<Error503 />
		</div>

		<!-- ローディング -->
		<div v-if="loading">
			<BaseLoading />
		</div>
	</div>
</template>

<script>
import Error500 from "./components/systems/Error500.vue";
import Error503 from "./components/systems/Error503.vue";
import Closed from "./components/systems/Closed.vue";

import TheGlobal from "./components/global/TheGlobal.vue";
import TheExtra from "./components/global/TheExtra.vue";
import TheExtraSNS from "./components/global/TheExtraSNS.vue";
import TheFooter from "./components/global/TheFooter.vue";
import TheBottom from "./components/global/TheBottom.vue";

import route from "@/router";

import BaseLoading from "@/components/items/BaseLoading.vue";

// デモサイトビルド時のみコメントイン
import BaseColor from "@/components/items/BaseColor.vue";

export default {
	components: {
		Error500,
		Error503,
		Closed,
		TheGlobal,
		TheExtra,
		TheExtraSNS,
		TheFooter,
		TheBottom,
		BaseLoading,

		// デモサイトビルド時のみコメントイン
		BaseColor
	},

	data() {
		return {
			status_code: "",

			global: [],
			extra: [],
			footer: [],
			bottom: [],
			organization: {},
			information: {},
			sns: {},
			rss: {},
			open_type: "",
			onesignal: "",

			loading: true,
			pageAnimation: "fade",

			userAgent: "",
		};
	},

	created() {
		// 外部JSファイルの読み込み
		let recaptchaScript = document.createElement('script')
		recaptchaScript.setAttribute('src', process.env.VUE_APP_API_BASE_URL + 'ajax/libs/v1/iv.js')
		document.head.appendChild(recaptchaScript)

		// manifest.jsonの追加
		document
			.querySelector("link[rel='manifest']")
			.setAttribute("href", process.env.VUE_APP_STORAGE_URL + process.env.VUE_APP_SITE_ID + '/manifest.json');
			
		// ルーティングの追加
		const routes = [];
		this.axios.get(process.env.VUE_APP_STORAGE_URL + 'common/data/route.json').then(function(res) {
			res.data.forEach(function(v){
				routes.push({
					path: v.path,
					name: v.name,
					component:() => import(/* webpackChunkName: "view-[request]" */ `@/components/${v.file}.vue`)
				});
			});
			route.addRoutes(routes);
		})

		// safariのみmp4ファイルをキャッシュから取り除く
		this.userAgent = navigator.userAgent;
		setInterval(() => {
			if (
				this.userAgent.indexOf("Safari") != -1 &&
				this.userAgent.indexOf("Chrome") == -1
			) {
				navigator.serviceWorker.controller.postMessage("updateCache");
				window.location.reload(true);
			}
		}, 60 * 60 * 1000);
	},

	mounted() {
		this.axios.get("/settings").then((response) => {
			if(this.$route.query.mode == 'preview') {
				this.open_type = 1;
			}else{
				this.open_type = response.data.response.open_type;
			}
			this.onesignal = response.data.response.onesignal.app_id;
			this.global = response.data.response.navigation.global;
			this.extra = response.data.response.navigation.extra;
			this.footer = response.data.response.navigation.footer;
			this.bottom = response.data.response.navigation.bottom;
			this.organization = response.data.response.organization;
			this.information = response.data.response.information;
			this.sns = response.data.response.sns;
			this.rss = response.data.response.blog;
			this.status_code = response.status;
			this.preview = true;
			// カラースキームの設定
			document.body.classList = "theme-a__" + this.information.color_scheme;

			document
				.querySelector("link[rel='icon']")
				.setAttribute("href", this.information.favicon_image);
			this.loading = false

			setTimeout(() => {
				if(this.open_type == 0 && this.onesignal !== null) {
					const el =  document.getElementById('onesignal-bell-container')
					el.classList.add('d-none')
				}
			}, 300);
		})
		.catch((error) => {
			this.status_code = error.response.status;
			this.loading = false
		});

		this.$ga.page(this.$route.path);
	},

	watch: {
		$route: function (to, from) {
			if (to.path !== from.path) {
				this.$ga.page(this.$route.path);
			}
		},
	},
};
</script>

<style lang="scss"></style>
